import React from 'react'
import Support from 'src/app/Support/Support'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { supportRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const SupportAppRoute: AppRoute = {
  id: AppLocation.Support,
  routeProps: supportRouteProps,
  component: <Support />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default SupportAppRoute
